/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

import { isAppAuthSelector } from 'pricing-pages-ui/selectors/AuthSelectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Loadable from 'UIComponents/decorators/Loadable';

/**
 * A wrapper for Loadable that will pass common props from a common prop hook
 * to both the loading and loaded component
 *
 * @param componentLoader The loader for the full component
 * @param componentProps Props to be passed to the loading and loaded component
 * @param ComponentLoadingState The component for the loading state
 * @param useCommonComponentProps A hook to transform componentProps into any calculated props that will be needed
 * for both the loading and loaded component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const LoadableWrapper = ({
  componentLoader,
  componentProps,
  ComponentLoadingState,
  useCommonComponentProps = () => ({}),
  errorMessage
}) => {
  const commonProps = useCommonComponentProps(componentProps);
  const ComponentLoadable = useMemo(() => Loadable({
    loader: componentLoader,
    LoadingComponent: () => ComponentLoadingState ? /*#__PURE__*/_jsx(ComponentLoadingState, Object.assign({}, componentProps, commonProps)) : null,
    ErrorComponent: () => {
      throw new Error(errorMessage);
    }
  }), []);
  return /*#__PURE__*/_jsx(ComponentLoadable, Object.assign({}, componentProps, commonProps));
};
// Code splits between an authed component and a public component
// Takes in a loader so we can do the code splitting inside this function.
// See LoadableWrapper above for what the props here mean
const CodeSplitEnvWrapper = ({
  authedComponentLoader,
  authedComponentProps,
  authedComponentLoadingState,
  useCommonAuthedProps,
  publicComponentLoader,
  publicComponentProps,
  publicComponentLoadingState,
  useCommonPublicProps
}) => {
  const isAppAuth = useSelector(isAppAuthSelector);
  const hasNoComponentForEnv = isAppAuth && !authedComponentLoader || !isAppAuth && !publicComponentLoader;
  if (hasNoComponentForEnv) return null;
  return /*#__PURE__*/_jsx(LoadableWrapper, {
    componentLoader: isAppAuth ? authedComponentLoader : publicComponentLoader,
    componentProps: isAppAuth ? authedComponentProps : publicComponentProps,
    useCommonComponentProps: isAppAuth ? useCommonAuthedProps : useCommonPublicProps,
    ComponentLoadingState: isAppAuth ? authedComponentLoadingState : publicComponentLoadingState,
    errorMessage: `EnvironmentWrapper ${isAppAuth ? 'authed' : 'public'} component Loadable error`
  });
};
export default CodeSplitEnvWrapper;